import './WrappedTextInput.pcss';
import React from 'react';
import FormFieldWrapper from '../FormFieldWrapper/FormFieldWrapper';
import TextInput from '../TextInput';
import classnames from 'classnames';

type Props = {
  label?: string;
  formProps: any;
  fieldName: string;
  required?: boolean;
  className?: string;
  inputClassName?: string;
  [key: string]: any;
  icon?: JSX.Element;
  inputIcon?: JSX.Element;
};

const WrappedTextInput = (props: Props) => {
  const {
    label,
    formProps,
    fieldName,
    className,
    inputClassName,
    required,
    icon,
    inputIcon,
    ...rest
  } = props;

  const classList = classnames('wrapped-text-input', className, {
    'wrapped-text-input--required': required,
  });

  return (
    <FormFieldWrapper
      className={classList}
      label={label}
      error={formProps.errors[fieldName]}
      touched={formProps.touched[fieldName]}
    >
      {icon && icon}
      <div className="text-input-component">
        <TextInput
          name={fieldName}
          className={inputClassName}
          onChange={formProps.handleChange}
          onBlur={formProps.handleBlur}
          value={formProps.values[fieldName]}
          error={formProps.errors[fieldName] && formProps.touched[fieldName]}
          {...rest}
        />
        {inputIcon && inputIcon}
      </div>
    </FormFieldWrapper>
  );
};

export { WrappedTextInput };
